<template>
  <div class="exhibition">
    <Head></Head>
    <div class="container" v-if="isPhone==false">
      <div class="block1">
        <img alt="xxx" src="../../assets/exhibition-cd/imgs/101.png" style="width: 100%;" />
      </div>
      <div class="block2">
        <img alt="xxx" src="../../assets/exhibition-cd/imgs/102.png" style="width: 100%;" />
      </div>
      <div class="block3">
        <div v-if="navIndex==1">
          <div class="navigation">
            <div class="nav1 navBlue" @click="changeNav1()">
              <span class="navSelect">车展概况</span>
            </div>
            <div class="nav2" @click="changeNav2()">最新信息</div>
            <div class="nav3" @click="changeNav3()">展台亮点</div>
            <div style="clear: both;"></div>
          </div>
          <div class="content1">
            <div class="contain">
              <div class="left">
                <img alt="xxx" src="../../assets/exhibition-cd/imgs/103.png" style="width: 100%;" />
              </div>
              <div class="right">
                <div class="text">
                  第二十三届成都国际车展于2020年7月24日 - 8月2日在中国西部国际博览城盛大举行。
                  <br />上汽大众携多款重磅车型亮相车展，让我们一起相约成都。
                </div>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div v-if="navIndex==2">
          <div class="navigation">
            <div class="nav1" @click="changeNav1()">车展概况</div>
            <div class="nav2 navBlue" @click="changeNav2()">
              <span class="navSelect">最新信息</span>
            </div>
            <div class="nav3" @click="changeNav3()">展台亮点</div>
            <div style="clear: both;"></div>
          </div>
          <div class="content2">
            <div class="contain">
              <div
                class="item"
                onclick="window.location='https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2783'"
              >
                <div class="left">
                  <img alt="xxx" src="../../assets/exhibition-cd/imgs/104.jpg" style="width: 100%;" />
                </div>
                <div class="right">
                  <div class="title-ex">威然领衔 大众品牌SUV天团聚力 上汽大众实力亮相成都车展</div>
                  <div
                    class="text"
                  >7月24日，上汽大众大众品牌携新近上市的威然登陆中国西部国际博览城2号馆，旗下SUV家族也全员亮相，聚焦展台目光，尽显合资SUV“第一家族”的磅礴风采。此次成都车展，上汽大众还特别面向西南市场提供威然尊享限定版，为消费者带来六重豪礼，力度空前。</div>
                </div>
                <div style="clear: both;"></div>
              </div>
              <div
                class="item"
                onclick="window.location='https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2784'"
              >
                <div class="left">
                  <img alt="xxx" src="../../assets/exhibition-cd/imgs/105.jpg" style="width: 100%;" />
                </div>
                <div class="right">
                  <div class="title-ex">2020成都车展 上汽斯柯达迎第300万位车主</div>
                  <div
                    class="text"
                  >7月24日，在第二十三届成都国际汽车展览会（以下简称：成都国际车展）上，上汽斯柯达迎来第300万位车主。来自成都的刘先生在展台上接过了上汽斯柯达第300万辆汽车——柯珞克的钥匙。斯柯达品牌在中国的终端销量突破300万辆，开启了陪伴用户的新旅程。</div>
                </div>
                <div style="clear: both;"></div>
              </div>

              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
        <div v-if="navIndex==3">
          <div class="navigation">
            <div class="nav1" @click="changeNav1()">车展概况</div>
            <div class="nav2" @click="changeNav2()">最新信息</div>
            <div class="nav3 navBlue" @click="changeNav3()">
              <span class="navSelect">展台亮点</span>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="content3">
            <div class="select-contain clickStyle">
              <div
                :class="{ 'select-option select-option-right': css3,'select-option-active':Activecss3 }"
                id="item-select3"
                @click="selectChange(3)"
              >车展花絮</div>
              <div
                :class="{ 'select-option': css2,'select-option-active':Activecss2 }"
                id="item-select2"
                @click="selectChange(2)"
              >斯柯达品牌车型</div>
              <div
                :class="{ 'select-option': css1,'select-option-active':Activecss1 }"
                id="item-select1"
                @click="selectChange(1)"
              >大众品牌车型</div>
              <div style="clear: both;"></div>
            </div>
            <div class="contain" v-if="sec3Type==1">
              <div v-bind:key="item.text" v-for="item in picsArr" class="box">
                <div class="left" @click="showPop(item.url1)">
                  <img alt="xxx" :src="item.url1" style="width: 100%;" />
                  <div class="text">{{item.text1}}</div>
                </div>
                <div class="middle" v-if="item.url2" @click="showPop(item.url2)">
                  <img alt="xxx" :src="item.url2" style="width: 100%;" />
                  <div class="text">{{item.text2}}</div>
                </div>
                <div class="right" v-if="item.url3" @click="showPop(item.url3)">
                  <img alt="xxx" :src="item.url3" style="width: 100%;" />
                  <div class="text">{{item.text3}}</div>
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
            <div class="contain" v-if="sec3Type==2">
              <div v-bind:key="item.text" v-for="item in picsArr" class="box">
                <div class="left" @click="showPop(item.url1)">
                  <img alt="xxx" :src="item.url1" style="width: 100%;" />
                </div>
                <div class="middle" v-if="item.url2" @click="showPop(item.url2)">
                  <img alt="xxx" :src="item.url2" style="width: 100%;" />
                </div>
                <div class="right" v-if="item.url3" @click="showPop(item.url3)">
                  <img alt="xxx" :src="item.url3" style="width: 100%;" />
                </div>
                <div style="clear: both;"></div>
              </div>
            </div>
          </div>
          <div class="cover" v-if="showCover"></div>
          <div class="popup" v-if="showCover">
            <div>
              <div class="close" @click="closePop()">
                <img alt="xxx" src="../../assets/imgs/close-pop.png" style="width: 100%;" />
              </div>
              <div class="img">
                <img alt="xxx" :src="popUrl" style="width: 100%;" />
              </div>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <ExhibitionMobile v-if="isPhone"></ExhibitionMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import { getBrowserType, getBrowserHight } from "../../components/js/screen.js";
import ExhibitionMobile from "./ExhibitionMobile";
import Head from "../../components/header-index.vue";
import Foot from "../../components/footer-index.vue";
export default {
  name: "Exhibition",
  components: {
    ExhibitionMobile,
    Head,
    Foot,
  },
  data() {
    return {
      isPhone: false,
      navIndex: 1, // 导航页签
      sec3Type: 1, // 第三个图片的类型
      showCover: false,
      popUrl: require("../../assets/exhibition-cd/imgs/311.jpg"),
      sec3Type: 1, // 第三个图片的类型
      selectItem: "1",
      selectTtems: [
        { id: "1", value: "大众品牌车型" },
        { id: "2", value: "斯柯达品牌车型" },
        { id: "3", value: "车展花絮" },
      ],
      picsArr: [],
      css1: true,
      Activecss1: false,
      css2: true,
      Activecss2: false,
      css3: true,
      Activecss3: false,
    };
  },
  mounted: function () {
    // 判断是否手机
    this.getIsPhone();
    this.setTitle();
  },
  methods: {
    changeNav1() {
      this.navIndex = 1;
    },
    changeNav2() {
      this.navIndex = 2;
    },
    changeNav3() {
      this.navIndex = 3;
      this.change1();
      setTimeout(() => {
        this.selectChange(1);
      }, 10);
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "成都国际车展";
    },
    showPop(url) {
      this.showCover = true;
      this.popUrl = url;
    },
    closePop() {
      this.showCover = false;
    },
    selectChange(index) {
      if (index == 1) {
        this.change1();
        document.getElementById("item-select2").style.background = "";
        document.getElementById("item-select2").style.color =
          "rgba(51,51,51,1)";
        document.getElementById("item-select3").style.background = "";
        document.getElementById("item-select3").style.color =
          "rgba(51,51,51,1)";
        document.getElementById("item-select1").style.background =
          "rgba(0,119,200,1)";
        document.getElementById("item-select1").style.color =
          "rgba(255,255,255,1)";
        this.css1 = false;
        this.Activecss1 = true;
        this.css2 = true;
        this.Activecss2 = false;
        this.css3 = true;
        this.Activecss3 = false;
      } else if (index == 2) {
        this.change2();
        document.getElementById("item-select1").style.background = "";
        document.getElementById("item-select1").style.color =
          "rgba(51,51,51,1)";
        document.getElementById("item-select3").style.background = "";
        document.getElementById("item-select3").style.color =
          "rgba(51,51,51,1)";
        document.getElementById("item-select2").style.background =
          "rgba(0,119,200,1)";
        document.getElementById("item-select2").style.color =
          "rgba(255,255,255,1)";
        this.css1 = true;
        this.Activecss1 = false;
        this.css2 = false;
        this.Activecss2 = true;
        this.css3 = true;
        this.Activecss3 = false;
      } else if (index == 3) {
        this.change3();
        document.getElementById("item-select1").style.background = "";
        document.getElementById("item-select1").style.color =
          "rgba(51,51,51,1)";
        document.getElementById("item-select2").style.background = "";
        document.getElementById("item-select2").style.color =
          "rgba(51,51,51,1)";
        document.getElementById("item-select3").style.background =
          "rgba(0,119,200,1)";
        document.getElementById("item-select3").style.color =
          "rgba(255,255,255,1)";
        this.css1 = true;
        this.Activecss1 = false;
        this.css2 = true;
        this.Activecss2 = false;
        this.css3 = false;
        this.Activecss3 = true;
      }
    },
    change1() {
      this.sec3Type = 1;
      this.picsArr = [
        {
          text1: "Viloran 威然",
          url1: require("../../assets/exhibition-cd/imgs/316.jpg"),
          text2: "Teramont X 途昂X",
          url2: require("../../assets/exhibition-cd/imgs/314.jpg"),
          text3: "Teramont 途昂",
          url3: require("../../assets/exhibition-cd/imgs/315.jpg"),
        },
        {
          text1: "Tiguan L 途观L",
          url1: require("../../assets/exhibition-cd/imgs/313.jpg"),
          text2: "Tharu 途岳",
          url2: require("../../assets/exhibition-cd/imgs/312.jpg"),
          text3: "T-Cross 途铠",
          url3: require("../../assets/exhibition-cd/imgs/311.jpg"),
        },
        {
          text1: "PHIDEON 辉昂",
          url1: require("../../assets/exhibition-cd/imgs/3112.jpg"),
          text2: "All New Passat 全新一代帕萨特",
          url2: require("../../assets/exhibition-cd/imgs/3111.jpg"),
          text3: "Passat PHEV 帕萨特插电式混合动力版",
          url3: require("../../assets/exhibition-cd/imgs/3114.jpg"),
        },
        {
          text1: "New Lamando 全新凌渡",
          url1: require("../../assets/exhibition-cd/imgs/3110.jpg"),
          text2: "e-Lavida 朗逸纯电",
          url2: require("../../assets/exhibition-cd/imgs/3113.jpg"),
          text3: "All New Lavida 全新一代朗逸",
          url3: require("../../assets/exhibition-cd/imgs/319.jpg"),
        },
        {
          text1: "New Santana 新桑塔纳",
          url1: require("../../assets/exhibition-cd/imgs/318.jpg"),
          text2: "All New Polo Plus 全新一代Polo Plus",
          url2: require("../../assets/exhibition-cd/imgs/317.jpg"),
        },
      ];
    },
    change2() {
      this.sec3Type = 1;
      this.picsArr = [
        {
          text1: "KODIAQ 柯迪亚克",
          url1: require("../../assets/exhibition-cd/imgs/324.jpg"),
          text2: "KAROQ 柯珞克",
          url2: require("../../assets/exhibition-cd/imgs/323.jpg"),
          text3: "KAMIQ 柯米克",
          url3: require("../../assets/exhibition-cd/imgs/321.jpg"),
        },
        {
          text1: "KODIAQ GT 柯迪亚克GT",
          url1: require("../../assets/exhibition-cd/imgs/325.jpg"),
          text2: "KAMIQ GT 柯米克GT",
          url2: require("../../assets/exhibition-cd/imgs/322.jpg"),
          text3: "SUPERB 速派",
          url3: require("../../assets/exhibition-cd/imgs/328.jpg"),
        },
        {
          text1: "OCTAVIA 明锐",
          url1: require("../../assets/exhibition-cd/imgs/327.jpg"),
          text2: "NEW RAPID 全新昕锐",
          url2: require("../../assets/exhibition-cd/imgs/326.jpg"),
        },
      ];
    },
    change3() {
      this.sec3Type = 2;
      this.picsArr = [
        {
          url1: require("../../assets/exhibition-cd/imgs/331.jpg"),
          url2: require("../../assets/exhibition-cd/imgs/332.jpg"),
          url3: require("../../assets/exhibition-cd/imgs/333.jpg"),
        },
        {
          url1: require("../../assets/exhibition-cd/imgs/334.jpg"),
          url2: require("../../assets/exhibition-cd/imgs/335.jpg"),
          url3: require("../../assets/exhibition-cd/imgs/336.jpg"),
        },
        {
          url1: require("../../assets/exhibition-cd/imgs/337.jpg"),
          url2: require("../../assets/exhibition-cd/imgs/338.jpg"),
          url3: require("../../assets/exhibition-cd/imgs/338-9.jpg"),
        },
        {
          url1: require("../../assets/exhibition-cd/imgs/339.jpg"),
          url2: require("../../assets/exhibition-cd/imgs/3310.jpg"),
          url3: require("../../assets/exhibition-cd/imgs/3311.jpg"),
        },
      ];
    },
  },
};
</script>

<style scoped>
.clickStyle {
  cursor: pointer;
}
.container {
  position: relative;
  width: 100%;
  min-width: 1024px;
}
@media screen and (min-width: 1px) {
  .block2 {
    padding: 0 300px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 24px;
    line-height: 37px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }
  .navigation .navSelect {
    border-bottom: solid 2px rgba(0, 119, 199, 1);
    padding-bottom: 10px;
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 20px;
    line-height: 40px;
    color: rgba(51, 51, 51, 1);
    padding-left: 80px;
    padding-top: 120px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 20px;
    line-height: 44px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 66px;
    margin-top: 50px;
  }
  .content2 .right .text {
    font-size: 16px;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
    margin-left: 66px;
    margin-top: 20px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 300px;
    margin-right: 300px;
  }
  .content3 .select-contain {
    font-weight: 400;
    width: 100%;
    font-size: 16px;
    line-height: 28px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 160px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    color: rgba(51, 51, 51, 1);
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-top: solid 1px rgba(51, 51, 51, 1);
    border-bottom: solid 1px rgba(51, 51, 51, 1);
  }
  .content3 .select-option-active {
    position: relative;
    float: right;
    width: 160px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    border-left: solid 1px rgba(0, 119, 200, 1);
    border-top: solid 1px rgba(0, 119, 200, 1);
    border-bottom: solid 1px rgba(0, 119, 200, 1);
  }
  .content3 .select-option-right {
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 40px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 20px;
    line-height: 24px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 25px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 800px;
    height: 571.4px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 20px;
    cursor: pointer;
  }
}

@media screen and (min-width: 1px) and (max-width: 1300px) {
  .block2 {
    padding: 0 100px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 100px;
    margin-right: 100px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 13px;
    line-height: 27px;
    color: rgba(51, 51, 51, 1);
    padding-left: 60px;
    padding-top: 120px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 100px;
    margin-right: 100px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 40px;
  }
  .content2 .right .text {
    font-size: 11px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 17px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 200px;
    margin-right: 200px;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 108px;
    height: 27px;
    font-size: 12px;
    line-height: 27px;
    color: rgba(51, 51, 51, 1);
  }
  .content3 .select-option-active {
    position: relative;
    float: right;
    width: 108px;
    height: 27px;
    font-size: 12px;
    line-height: 27px;
    color: rgba(255, 255, 255, 1);
    border-left: solid 1px rgba(0, 119, 200, 1);
    border-top: solid 1px rgba(0, 119, 200, 1);
    border-bottom: solid 1px rgba(0, 119, 200, 1);
  }
  .content3 .contain {
    position: relative;
    width: 100%;
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 25px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 13px;
    line-height: 16px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 17px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 600px;
    height: 428.6px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 15px;
    cursor: pointer;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .block2 {
    padding: 0 134px;
  }
  /* 导航栏 */
  .navigation {
    position: relative;
    width: 500px;
    text-align: center;
    left: 50%;
    margin-left: -250px;
  }
  .navigation .nav1 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .nav2 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
    border-left: solid 1px rgba(51, 51, 51, 1);
    border-right: solid 1px rgba(51, 51, 51, 1);
  }
  .navigation .nav3 {
    position: relative;
    float: left;
    font-size: 20px;
    color: rgba(51, 51, 51, 1);
    cursor: pointer;
    width: 33%;
  }
  .navigation .navBlue {
    font-weight: bold;
    color: rgba(0, 119, 199, 1);
  }

  /* 第一个导航栏 */
  .content1 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 134px;
    margin-right: 134px;
  }
  .content1 .contain {
    position: relative;
  }
  .content1 .left {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right {
    position: relative;
    float: left;
    width: 50%;
  }
  .content1 .right .text {
    font-size: 16px;
    line-height: 33px;
    color: rgba(51, 51, 51, 1);
    padding-left: 70px;
    padding-top: 100px;
  }
  /* 第二个导航栏 */
  .content2 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 134px;
    margin-right: 134px;
  }
  .content2 .contain {
    position: relative;
  }
  .content2 .contain .item {
    margin-top: 20px;
    cursor: pointer;
  }
  .content2 .left {
    position: relative;
    float: left;
    width: 30%;
  }
  .content2 .right {
    position: relative;
    float: left;
    width: 70%;
  }

  .content2 .right .title-ex {
    font-size: 14px;
    line-height: 30px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 70px;
  }
  .content2 .right .text {
    font-size: 11px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    margin-left: 45px;
    margin-top: 20px;
  }
  /* 第三个导航栏 */
  .content3 {
    margin-top: 80px;
    margin-bottom: 40px;
    margin-left: 250px;
    margin-right: 250px;
  }
  .content3 .select-contain {
  }
  .content3 .select-option {
    position: relative;
    float: right;
    width: 133px;
    height: 33px;
    font-size: 13px;
    line-height: 33px;
    color: rgba(51, 51, 51, 1);
  }
  .content3 .select-option-active {
    position: relative;
    float: right;
    width: 133px;
    height: 33px;
    font-size: 13px;
    line-height: 33px;
    color: rgba(255, 255, 255, 1);
    border-left: solid 1px rgba(0, 119, 200, 1);
    border-top: solid 1px rgba(0, 119, 200, 1);
    border-bottom: solid 1px rgba(0, 119, 200, 1);
  }
  .content3 .contain {
    position: relative;
    width: 100%;
  }
  .content3 .contain .box {
    position: relative;
    width: 100%;
    margin-top: 40px;
  }
  .content3 .contain .box img {
    cursor: pointer;
  }
  .content3 .contain .box .left {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-right: 8px;
  }
  .content3 .contain .box .middle {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 4px;
    padding-right: 4px;
  }
  .content3 .contain .box .right {
    position: relative;
    float: left;
    width: calc(33.33333333% - 8px);
    padding-left: 8px;
  }
  .content3 .contain .text {
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    margin-top: 25px;
  }
  .block3 .cover {
    position: fixed;
    /*首先将位置固定住*/
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /*上下左右设置都为0*/
    background: rgba(2, 2, 2, 0.5);
  }
  .block3 .popup {
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 700px;
    height: 500px;
  }
  .block3 .popup .close {
    position: relative;
    float: right;
    width: 15px;
    cursor: pointer;
  }
}
</style>